import React from "react";
import {
  Box,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell as MuiTableCell,
  TableBody,
  Paper,
  Typography,
  Stack,
  styled,
} from "@mui/material";
import conferenceData from "../../utils/ConferencePaperPresentation.json";

type ConferencePresentation = {
  date: string;
  title: string;
  conference: string;
  presenter: string;
  organizer: string;
  place: string;
  level: string;
  department: string;
};

const TableCell = styled(MuiTableCell)(({ theme }) => ({
  fontSize: 14,
  textAlign: "left",
  color: theme.palette.primary.contrastText,
}));

function ConferencePaperPresentation() {
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
        spacing={2}
      >
        <Typography
          variant="h6"
          sx={{
            p: 2,
            backgroundColor: "primary.main",
            color: "white",
            width: "100%",
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          Conference Paper Presentations
        </Typography>
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">Date</TableCell>
                <TableCell align="center">Conference</TableCell>
                <TableCell align="center">Presenter</TableCell>
                <TableCell align="center">Organizer</TableCell>
                <TableCell align="center">Place</TableCell>
                <TableCell align="center">Level</TableCell>
                <TableCell align="center">Department</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {conferenceData?.length > 0 ? (
                conferenceData.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell align="center">{item.Date}</TableCell>
                    <TableCell align="center">{item.Conference}</TableCell>
                    <TableCell align="center">{item.Presenter}</TableCell>
                    <TableCell align="center">{item.Organizer}</TableCell>
                    <TableCell align="center">{item.Place}</TableCell>
                    <TableCell align="center">{item.Level}</TableCell>
                    <TableCell align="center">{item.Department}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow sx={{ textAlign: "center" }}>
                  <TableCell
                    colSpan={7}
                    align="center"
                    style={{ textAlign: "center" }}
                  >
                    {"No data Found!"}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </Box>
  );
}

export default ConferencePaperPresentation;
